import React from 'react';
import { Reveal } from './ui/Reveal';
import { Search, PenTool, Video, Rocket } from 'lucide-react';

export const Process: React.FC = () => {
  const steps = [
    {
      icon: <Search className="w-6 h-6 md:w-8 md:h-8" />,
      title: "Analisi di Mercato",
      description: "Individuiamo il gap nella tua nicchia."
    },
    {
      icon: <PenTool className="w-6 h-6 md:w-8 md:h-8" />,
      title: "Strategia Virale",
      description: "Script progettati per trattenere l'attenzione."
    },
    {
      icon: <Video className="w-6 h-6 md:w-8 md:h-8" />,
      title: "Produzione Contenuti",
      description: "Shooting e montaggio professionali."
    },
    {
      icon: <Rocket className="w-6 h-6 md:w-8 md:h-8" />,
      title: "Pubblicazione & Scaling",
      description: "Pubblicazione costante e crescita della community."
    }
  ];

  return (
    <section id="process" className="py-24 md:py-32 bg-white text-black relative overflow-hidden">
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="mb-16 md:mb-24 text-center">
            <Reveal width="100%">
                <h2 className="text-4xl md:text-6xl font-bold mb-6 font-['Space_Grotesk']">COME LAVORIAMO</h2>
            </Reveal>
        </div>

        {/* 
            Grid Configuration:
            Mobile/Tablet: 1 Column (Vertical List)
            Desktop: 4 Columns (Horizontal Flow)
        */}
        <div className="relative grid grid-cols-1 lg:grid-cols-4 gap-12 lg:gap-8">
          
          {/* Connector Lines Layer */}
          <div className="absolute inset-0 pointer-events-none z-0">
             {/* 
                Desktop Horizontal Line 
                Positioned at top-12 (3rem = 48px) to cut through the middle of the icons (w-24 = 6rem = 96px, center is 48px) 
             */}
             <div className="hidden lg:block absolute top-12 left-[12%] right-[12%] border-t-2 border-dashed border-zinc-200" />
             
             {/* 
                Mobile/Tablet Vertical Line 
                Positioned to align with the center of the icons on the left side.
                Icon width is w-24 (96px) -> Center is 48px (3rem).
                left-12 equals 3rem.
             */}
             <div className="lg:hidden absolute top-6 bottom-6 left-12 border-l-2 border-dashed border-zinc-200" />
          </div>

          {steps.map((step, idx) => (
            <div key={idx} className="relative group z-10">
              <Reveal delay={idx * 0.1} width="100%">
                {/* 
                    Item Layout:
                    Mobile: Flex Row (Icon Left, Text Right)
                    Desktop: Flex Col (Icon Top, Text Bottom)
                */}
                <div className="flex flex-row lg:flex-col items-start lg:items-center gap-6 lg:gap-0 relative">
                    
                    {/* Icon Wrapper */}
                    <div className="shrink-0 relative">
                        {/* 
                            Background Number
                            Mobile: Centered horizontally, slightly above (-top-6)
                            Desktop: Centered horizontally, more above (-top-12)
                        */}
                        <div className="absolute -top-6 left-1/2 -translate-x-1/2 lg:-top-12 lg:left-1/2 lg:-translate-x-1/2 text-6xl lg:text-9xl font-bold text-gray-50 -z-10 select-none opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            {idx + 1}
                        </div>

                        {/* 
                            Icon Circle 
                            REMOVED: scale effects on hover for both mobile and desktop.
                            Now purely color transition.
                        */}
                        <div className="w-24 h-24 rounded-full bg-white text-black flex items-center justify-center border border-zinc-200 group-hover:bg-black group-hover:text-white group-hover:border-black transition-all duration-300 relative z-20">
                            {step.icon}
                            
                            {/* Dot - Always centered at bottom for timeline continuity */}
                            <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-zinc-300 rounded-full group-hover:bg-white transition-colors border-2 border-white lg:border-none" />
                        </div>
                    </div>
                    
                    {/* Text Content */}
                    <div className="pt-2 lg:pt-8 text-left lg:text-center flex-1 pl-4 lg:pl-0">
                        <h3 className="text-xl md:text-2xl font-bold mb-2 font-['Space_Grotesk']">{step.title}</h3>
                        <p className="text-gray-500 leading-relaxed max-w-xs lg:mx-auto text-sm md:text-base">{step.description}</p>
                    </div>
                </div>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};